import React, { useState, useEffect } from 'react';

function formatTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const now = new Date();
  const diff = now - d;
  if (diff < 60000) return 'just now';
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}h ago`;
  return d.toLocaleDateString();
}

export default function Discord({ api }) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noToken, setNoToken] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const statusR = await fetch(`${api}/api/status`);
        const status = await statusR.json();
        if (!status.has_discord) {
          setNoToken(true);
          setLoading(false);
          return;
        }
        const r = await fetch(`${api}/api/discord`);
        const d = await r.json();
        setMessages(d);
      } catch (e) { console.error(e); }
      setLoading(false);
    };
    load();
    const interval = setInterval(load, 60000); // Refresh every minute
    return () => clearInterval(interval);
  }, [api]);

  if (loading) return (
    <div className="loading"><div className="spinner" /><span>Loading Discord feed...</span></div>
  );

  if (noToken) return (
    <div className="empty-state">
      <div style={{ fontSize: '3rem', marginBottom: 16 }}>💬</div>
      <p style={{ marginBottom: 8, fontWeight: 600, color: 'var(--text)' }}>Discord Not Connected</p>
      <p style={{ maxWidth: 400, margin: '0 auto', lineHeight: 1.6 }}>
        Add your Discord Bot Token to the <code style={{ color: 'var(--accent)', background: 'var(--bg3)', padding: '1px 5px', borderRadius: 3 }}>.env</code> file to enable the live feed from <strong>#Commissioner-Announcements</strong>.
      </p>
      <p style={{ marginTop: 12, fontSize: '0.8rem', color: 'var(--text3)' }}>
        Set <code style={{ color: 'var(--accent2)' }}>DISCORD_BOT_TOKEN=your_token_here</code> and restart the server.
      </p>
    </div>
  );

  if (!messages.length) return (
    <div className="empty-state">
      <div style={{ fontSize: '2rem', marginBottom: 12 }}>📭</div>
      <p>No messages found in #Commissioner-Announcements.</p>
    </div>
  );

  return (
    <div>
      <div className="page-header">
        <div className="page-title">League Chat</div>
        <div className="page-subtitle">#Commissioner-Announcements · Updates every 60 seconds</div>
      </div>

      <div className="card">
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, paddingBottom: 12, borderBottom: '1px solid var(--border)' }}>
          <div style={{ width: 10, height: 10, background: 'var(--green)', borderRadius: '50%', boxShadow: '0 0 8px var(--green)' }} />
          <span style={{ fontSize: '0.8rem', color: 'var(--text2)', fontWeight: 500 }}>Live · #Commissioner-Announcements</span>
        </div>
        <div className="discord-feed">
          {messages.map(msg => (
            <div className="discord-msg" key={msg.id}>
              <div className="discord-meta">
                {msg.avatar ? (
                  <img className="discord-avatar" src={msg.avatar} alt={msg.author} onError={e => e.target.style.display = 'none'} />
                ) : (
                  <div className="discord-avatar-fallback">
                    {msg.author?.slice(0, 1).toUpperCase()}
                  </div>
                )}
                <span className="discord-author">{msg.author}</span>
                <span className="discord-time">{formatTime(msg.timestamp)}</span>
              </div>
              {msg.content && (
                <div className="discord-content">{msg.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
